import en from "./translations/en";
import fr from "./translations/fr";
import th from "./translations/th";

export const translations = {
  en,
  fr,
  th,
};
